export default "__VITE_ASSET__GLItzS_u__";